<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon type="left" :style="{ fontSize: '20px', color: '#333' }" @click="backPage" />
      <span>费控草稿箱</span>
    </div>
    <div class="con">
      <van-tabs v-model="active" color="#1584FF" animated :ellipsis="false" @click="handerTab">
        <van-tab title="借款申请单">
          <daraftListLoan></daraftListLoan>
        </van-tab>
        <van-tab title="费用报销单">
          <daraftListCost></daraftListCost>
        </van-tab>
        <van-tab title="付款申请单">
          <daraftListPayment></daraftListPayment>
        </van-tab>
        <van-tab title="差旅报销单">
          <daraftListTravel></daraftListTravel>
        </van-tab>
        <van-tab title="领款单">
          <daraftListReceive></daraftListReceive>
        </van-tab>
        <!-- <van-tab >
          占位
        </van-tab> -->
      </van-tabs>
    </div>
  </div>
</template>
<script>
import daraftListLoan from './components/daraftListLoan.vue';
import daraftListCost from './components/daraftListCost.vue';
import daraftListPayment from './components/daraftListPaymentMoney.vue';
import daraftListTravel from './components/daraftListTravel.vue';
import daraftListReceive from './components/daraftListReceive.vue';
export default {
  components: {
    daraftListLoan,
    daraftListCost,
    daraftListPayment,
    daraftListTravel,
    daraftListReceive,
  },
  data() {
    return {
      active: 0,
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.active = Number(val);
      }
    },
  },
  created() {
    if (this.$route.query.type != undefined) {
      this.active = Number(this.$route.query?.type) || 0;
    }
  },
  mounted() {},
  methods: {
    handerTab(name, title) {
      // console.log(name);
      // console.log(title);
    },
    backPage() {
      // 回退到app
      window.location.href = 'jsToOc://back';
    },
  },
};
</script>
<style lang="less" scoped>
.head-navigate {
  position: sticky;
  top: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.3rem 0.3rem;
  border-bottom: 1px solid #f0f2f5;
}
/deep/.con {
  .van-tabs {
    .van-tabs__wrap {
      position: sticky;
      top: 49px;
      z-index: 99999;
    }
  }
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
</style>
